<template>
    <div>

        <v-text-field outlined dense label="رمز عبور جدید"
                      type="password"
                      v-model="password"
                      maxlength="255"
                      :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                      :rules="[rules.required, rules.min]"
                      :type="show1 ? 'text' : 'password'"
                      hint="حداقل 8 کاراکتر"
                      counter
                      @click:append="show1 = !show1"
        />

        <v-text-field

            label="تکرار رمز عبور" dense append-icon="mdi-account"
            type="password"
            v-model="confirmPassword"
            maxlength="255"
            :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
            :rules="[rules.required, rules.min, rules.equal]"
            :type="show2 ? 'text' : 'password'"
            hint="حداقل 8 کاراکتر"
            counter
            @click:append="show2 = !show2"
            outlined/>

        <v-btn color="primary" min-width="110" :loading="loading" v-on:click="changePassword">
            <v-icon>mdi-chevron-right</v-icon>
            تغییر رمز
        </v-btn>
    </div>
</template>

<script>
export default {
    name: 'ForgetPassword',
    props:['username', 'code'],
    data() {
        return {
            loading: false,
            show1: false,
            show2: false,
            password: '',
            confirmPassword:'',
            rules: {
                required: value => !!value || 'فیلد اجباری می باشد.',
                min: v => v.length >= 8 || 'فیلد شما کوچک تر از 8 کاراکتر است',
                equal: () => this.password === this.confirmPassword || 'فیلد رمز عبور با فیلد تکرار رمز عبور یکسان نیست'
            },
        }
    },

    methods:{
        changePassword(){
            if (!this.isEquals())
                return this.$toast.error('فیلد رمز عبور جدید با فیلد تکرار رمز عبور یکسان نیست');
            this.requestApiPost(`change-password/${this.code}`, {
                'username': this.username,
                'password': this.password,
                'confirmPassword': this.confirmPassword
            }).then(({data}) => {
                this.$toast.success(data.message)
              this.$emit('passChanged')
            }).catch(({response}) => {
                this.$toast.error(response.data.message)
            })
        },
        isEquals(){
            return this.password === this.confirmPassword;
        }
    },
}
</script>
